"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _Title = _interopRequireDefault(require("../Typography/Title"));

var _CloseIcon = _interopRequireDefault(require("../Icons/CloseIcon"));

var _Pagination = _interopRequireDefault(require("../Navigation/Pagination"));

var _Link = _interopRequireDefault(require("../Typography/Link"));

var _Select = _interopRequireDefault(require("../Select/Select"));

var _Paragraph = _interopRequireDefault(require("../Typography/Paragraph"));

var _Separator = _interopRequireDefault(require("../Separator/Separator"));

var _VerticalSeparator = _interopRequireDefault(require("../Separator/VerticalSeparator"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This is the dashboard header style that is commonly used on the Prism
 * dashboard page.
 */
var DashboardWidgetHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DashboardWidgetHeader, _React$Component);

  function DashboardWidgetHeader() {
    _classCallCheck(this, DashboardWidgetHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(DashboardWidgetHeader).apply(this, arguments));
  }

  _createClass(DashboardWidgetHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          title = _this$props.title,
          showCloseIcon = _this$props.showCloseIcon,
          onClose = _this$props.onClose,
          customInfo = _this$props.customInfo,
          supplementaryInfo = _this$props.supplementaryInfo,
          selectProps = _this$props.selectProps,
          paginationProps = _this$props.paginationProps,
          linkProps = _this$props.linkProps,
          props = _objectWithoutProperties(_this$props, ["className", "title", "showCloseIcon", "onClose", "customInfo", "supplementaryInfo", "selectProps", "paginationProps", "linkProps"]);

      var mergedClassnames = (0, _classnames.default)("".concat(_ThemeManager.default.getVar('classPrefix'), "-dashboard-widget-header"), showCloseIcon ? 'show-close' : '', className);
      var rightContent = [];
      var closeIcon = null;

      if (customInfo) {
        // If customInfo is a component without a key, React will throw a warning
        // because its a part of an array.
        if (_react.default.isValidElement(customInfo)) {
          var cloneCustomInfo = _react.default.cloneElement(customInfo, // If customInfo component has no key, we'll add one
          {
            key: customInfo.key || 'customInfo'
          });

          rightContent.push(cloneCustomInfo);
        } else {
          rightContent.push(customInfo);
        }
      }

      if (supplementaryInfo) {
        rightContent.push(_react.default.createElement(_Paragraph.default, {
          key: "supplementaryInfo",
          type: "supplementary"
        }, supplementaryInfo));
      }

      if (selectProps) {
        rightContent.push(_react.default.createElement(_Select.default, _extends({
          key: "select"
        }, selectProps)));
      }

      if (paginationProps) {
        rightContent.push(_react.default.createElement(_Pagination.default, _extends({
          key: "pagination"
        }, paginationProps)));
      }

      if (linkProps) {
        rightContent.push(_react.default.createElement(_Link.default, _extends({
          key: "link"
        }, linkProps)));
      }

      if (showCloseIcon) {
        var verticalSeparator = rightContent.length ? _react.default.createElement(_VerticalSeparator.default, null) : null;
        closeIcon = _react.default.createElement(_FlexLayout.default, {
          className: "close-icon-container",
          alignItems: "center",
          itemSpacing: "20px"
        }, verticalSeparator, _react.default.createElement(_CloseIcon.default, {
          key: "close",
          onClick: onClose
        }));
      }

      var rightContentNode = rightContent.length ? _react.default.createElement(_Separator.default, {
        className: "header-separator",
        separator: _react.default.createElement(_VerticalSeparator.default, null),
        spacing: "spacing-20px"
      }, rightContent) : null;
      var titleNode = title;

      if (typeof title === 'string') {
        titleNode = _react.default.createElement(_Title.default, {
          size: _Title.default.SIZES.H3,
          forceSingleLine: true
        }, title);
      }

      return _react.default.createElement(_FlexLayout.default, _extends({
        justifyContent: "space-between",
        alignItems: "center",
        className: mergedClassnames
      }, props), titleNode, rightContentNode, closeIcon);
    }
  }]);

  return DashboardWidgetHeader;
}(_react.default.Component);

exports.default = DashboardWidgetHeader;
DashboardWidgetHeader.defaultProps = {
  showCloseIcon: true
};
DashboardWidgetHeader.propTypes = {
  /**
   * Additional custom class name.
   */
  className: _propTypes.default.string,

  /**
   * The title used for the header.  Normally is a string but can React node.
   */
  title: _propTypes.default.node,

  /**
   * To show the close icon or not.
   */
  showCloseIcon: _propTypes.default.bool,

  /**
   * Function handler for the click on the close icon.
   */
  onClose: _propTypes.default.func,

  /**
   * Custom header info
   */
  customInfo: _propTypes.default.node,

  /**
   * Supplementary header info
   */
  supplementaryInfo: _propTypes.default.string,

  /**
   * Props for Select component
   */
  selectProps: _propTypes.default.object,

  /**
   * Props for pagination component
   */
  paginationProps: _propTypes.default.object,

  /**
   * Props for link component
   */
  linkProps: _propTypes.default.object
};